(() => {
  const drawerDetails = document.querySelector('header-drawer > details');
  if (!drawerDetails) return;

  let locked = false;
  let savedScrollY = 0;
  let previousHtmlOverflow = '';
  let previousBodyStyles = null;
  const mobileQuery = window.matchMedia('(max-width: 989px)');
  const drawer = drawerDetails.querySelector('.menu-drawer');
  const header = document.querySelector('.section-header');
  const announcement = document.querySelector('.announcement-bar-section');
  const visualViewport = window.visualViewport;

  const isMobile = () => mobileQuery.matches;

  const resetDrawerScroll = () => {
    if (!drawer) return;
    drawer.scrollTop = 0;
    drawer.querySelectorAll(
      '.menu-drawer__navigation-container, .menu-drawer__inner-submenu, .menu-drawer__submenu'
    ).forEach((element) => {
      element.scrollTop = 0;
      element.scrollLeft = 0;
    });
  };

  const syncDrawerViewport = () => {
    if (!isMobile()) return;

    const viewportHeight = Math.round(visualViewport?.height || window.innerHeight);
    const announcementHeight = Math.round(announcement?.getBoundingClientRect().height || 0);
    const headerHeight = Math.round(header?.getBoundingClientRect().height || 0);
    const drawerTop = Math.max(0, Math.min(viewportHeight, announcementHeight + headerHeight));

    document.documentElement.style.setProperty('--viewport-height', `${viewportHeight}px`);
    document.documentElement.style.setProperty('--header-bottom-position', `${drawerTop}px`);
    document.documentElement.style.setProperty('--difiney-menu-viewport-height', `${viewportHeight}px`);
    document.documentElement.style.setProperty('--difiney-menu-announcement-height', `${announcementHeight}px`);
    document.documentElement.style.setProperty('--difiney-menu-drawer-top', `${drawerTop}px`);
  };

  const preventBackgroundTouch = (event) => {
    if (!locked || event.target.closest('.menu-drawer')) return;
    event.preventDefault();
  };

  const lockAtCurrentPosition = () => {
    if (locked || !isMobile()) return;

    savedScrollY = window.scrollY;
    syncDrawerViewport();
    resetDrawerScroll();
    locked = true;
    previousHtmlOverflow = document.documentElement.style.overflow;
    previousBodyStyles = {
      position: document.body.style.position,
      top: document.body.style.top,
      left: document.body.style.left,
      right: document.body.style.right,
      width: document.body.style.width,
      overflow: document.body.style.overflow,
    };
    document.documentElement.classList.add('difiney-mobile-menu-open');
    document.body.classList.add('difiney-mobile-menu-open');
    document.documentElement.style.overflow = 'hidden';
    document.body.style.position = 'fixed';
    document.body.style.top = `-${savedScrollY}px`;
    document.body.style.left = '0';
    document.body.style.right = '0';
    document.body.style.width = '100%';
    document.body.style.overflow = 'hidden';
    document.addEventListener('touchmove', preventBackgroundTouch, { passive: false });
    window.addEventListener('resize', syncDrawerViewport);
    window.addEventListener('orientationchange', syncDrawerViewport);
    visualViewport?.addEventListener('resize', syncDrawerViewport);
    visualViewport?.addEventListener('scroll', syncDrawerViewport);

    requestAnimationFrame(() => {
      syncDrawerViewport();
      resetDrawerScroll();
    });
  };

  const restorePosition = () => {
    if (!locked) return;

    locked = false;
    const previousScrollBehavior = document.documentElement.style.scrollBehavior;
    document.documentElement.style.scrollBehavior = 'auto';
    document.documentElement.classList.remove('difiney-mobile-menu-open');
    document.body.classList.remove('difiney-mobile-menu-open');
    document.documentElement.style.overflow = previousHtmlOverflow;
    if (previousBodyStyles) {
      Object.assign(document.body.style, previousBodyStyles);
    }
    document.removeEventListener('touchmove', preventBackgroundTouch);
    window.removeEventListener('resize', syncDrawerViewport);
    window.removeEventListener('orientationchange', syncDrawerViewport);
    visualViewport?.removeEventListener('resize', syncDrawerViewport);
    visualViewport?.removeEventListener('scroll', syncDrawerViewport);
    window.scrollTo(0, savedScrollY);
    document.documentElement.style.scrollBehavior = previousScrollBehavior;
  };

  const syncDrawerState = () => {
    if (drawerDetails.open) {
      lockAtCurrentPosition();
    } else {
      restorePosition();
    }
  };

  new MutationObserver(syncDrawerState).observe(drawerDetails, {
    attributes: true,
    attributeFilter: ['open'],
  });

  window.addEventListener('pageshow', syncDrawerState);
  const handleBreakpointChange = () => {
    if (!isMobile()) restorePosition();
  };
  if (typeof mobileQuery.addEventListener === 'function') {
    mobileQuery.addEventListener('change', handleBreakpointChange);
  } else if (typeof mobileQuery.addListener === 'function') {
    mobileQuery.addListener(handleBreakpointChange);
  }
})();
